import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';

export class OwnerCode {

  @JsonProperty()
  id: number = -1;

  @JsonProperty()
  ownerId: number = -1;

  @JsonProperty()
  exchangeCode: string | undefined;

  @JsonProperty()
  ownerType: OwnerCode.OwnerType;

  @JsonProperty()
  ownerState: OwnerCode.OwnerState;

  @JsonProperty()
  code: string | undefined;

  @JsonProperty()
  clearingOrganization: string | undefined;

  @JsonProperty()
  source: string | undefined;

  @JsonProperty()
  modificationDate: DateTime = DateTime.now();

}

export module OwnerCode {
  export enum OwnerType {
    NCM = 'NCM',
    GCM = 'GCM',
  }

  export enum OwnerState {
    ACTIVE = 'ACTIVE',
    PASSIVE = 'PASSIVE',
  }
}
